import Skeleton from '@components/v2/ui/Skeleton/Skeleton';
import { Box } from '@mui/material';
import { BaseItem, VirtualizedItemTableProps } from './VirtualizedTable.types';

const VirtualizedCardTableSkeleton = <T extends BaseItem>({
  columns,
}: Pick<VirtualizedItemTableProps<T>, 'columns'>) => {
  return (
    <Box
      sx={(theme) => ({ display: 'grid', rowGap: theme.spacing(1), padding: theme.spacing(1.5) })}
    >
      <Skeleton height={38} variant="rectangular" animation="wave" />
      {columns.map((column) => (
        <Skeleton key={column.name} height={20} variant="rectangular" animation="wave" />
      ))}
    </Box>
  );
};

export default VirtualizedCardTableSkeleton;
